module.exports = __webpack_public_path__ + "static/media/crw.d21b8965.svg";